module.exports = __webpack_public_path__ + "img/7.4b432a3.jpg";